<template>
  <div :class="['home', { mb: isMobile }]" @click="handler">
    <!-- <Dot /> -->
    <div class="top">
      <img
        class="qr-img"
        src="@/assets/images/b/qr-img.png"
        @click="showDownloadImg"
      >
      <img :src="userInfo.avatar|serverimg_url('', 'avatar')" :onerror="errorImg" class="avatar" />
    </div>
    <div class="middle">
      <p class="name" v-text="userInfo.nickName"></p>
      <p class="content" v-html="content"></p>
      <!-- 支持下载的浏览器 -->
      <button v-if="isSupport" data-id="classInDownLoad_auto" class="download">
        {{ $t("addfriend.download") }}
      </button>
      <!-- 不支持下载的浏览器 -->
      <button v-else @click="download" class="download">
        {{ $t("addfriend.download") }}
      </button>
      <!-- 已下载唤起 -->
      <p class="clickOpen" @click="addFriend">
        {{ $t("addfriend.clickOpen") }}
      </p>
    </div>
    <div class="bottom"></div>
    <van-loading
      v-if="$root.loading"
      class="loading"
      :size="isMobile ? 80 : 40"
    />
    <MaskBox
      v-if="showMask"
      :userInfo="userInfo"
      :sq="sourceHash"
      @hide-mask="hideDownloadImg"
    />
  </div>
</template>

<script>
// import url from "url";
import serverimg_url from '@/filters/serverimg_url';
import api_addfriend from "@/api/addfriend/api_addfriend.js";
// import Dot from "./Dot.vue";
import MaskBox from '@/components/addfriend/DownloadImg.vue'
export default {
  data() {
    return {
      isMobile: window.browserVersion.mobile,
      errorImg:
        'this.src="' + require("@/assets/images/b/avatar_defalut.png") + '"',
      // sourceHash: url.parse(window.location.href, true).query.sq,
      showMask: false,
      content: "",
      userInfo: {
        avatar: "",
        nickName: "",
        telephone: "",
      },
    };
  },
  components: {
    MaskBox,
  },
  filters: {
    serverimg_url,
  },
  mounted() {
    this.sourceHash && this.getUserInfo();
  },
  computed: {
    isSupport() {
      let result = true
      let android = window.browserVersion.weixin && window.browserVersion.mobile && window.browserVersion.android
      let ios = (window.browserVersion.weixin && !this.isSupportIosVersion()) || 
                (window.browserVersion.mobile && window.browserVersion.ios && !(window.browserVersion.safari || window.browserVersion.weixin))
      result = android || ios
      return !result
    },
    sourceHash() {
      // 目前经过微信跳转后的页面URL参数sq中的特殊字符会被解码，此时url.parse(**, true).query获取的参数会
      // 将特殊字符“+”识别为运算符，导致参数“+”转换成空格，从而引起接口104报错，为避免此类问题且考虑目前参数中
      // 只有sq，所以暂时做如下处理，如果后续参数变多，需要修改此处设置
      const sq = decodeURIComponent(window.location.search.substring(1).replace('sq=', ''))
      return sq
    },
  },
  methods: {
    getUserInfo() {
      this.$root.loading = true;
      api_addfriend("get", {
        sourceHash: this.sourceHash,
        timeStamp: this.$root.serverShowTime,
      }).then((res) => {
        this.$root.loading = false;
        let resData = res.data;
        if (!resData) return;
        switch (resData) {
          case 10003:
            this.content = this.$t("addfriend.invalidContent");
            break;
          default:
            this.getShareData(resData);
            this.userInfo = {
              avatar: resData.avatar,
              nickName: resData.nickName,
              telephone: resData.telephone,
            };
            this.content = this.$t("addfriend.inviteContent", {
              name: resData.nickName,
            });
            break;
        }
      });
    },
    changeMeta(shareDataConfig) {
      document.title = shareDataConfig.title;

      var metaName = document.createElement("meta");
      metaName.setAttribute("itemprop", "name");
      metaName.content = shareDataConfig.title;
      document.head.appendChild(metaName);

      var metaImg = document.createElement("meta");
      metaImg.name = "image";
      metaImg.setAttribute("itemprop", "image");
      metaImg.content = shareDataConfig.imgUrl;
      document.head.appendChild(metaImg);

      var metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      metaDesc.setAttribute("itemprop", "description");
      metaDesc.content = shareDataConfig.desc;
      document.head.appendChild(metaDesc);
    },
    getShareData(resData) {
      var shareDataConfig = {
        title: this.$t("addfriend.shareInfo.title", { name: resData.nickName }),
        link: window.location.href.replace(window.location.host, window.EEOENV.share.main),
        imgUrl:
          serverimg_url(resData.avatar, '', 'avatar') ||
          "https://static.eeo.cn/assets/images/weixin-share.png",
      };
      this.changeMeta(shareDataConfig);
      window.eeoWxShare(shareDataConfig);
    },
    download() {
      if (!window.eeoRunWithoutWx()) {
        return;
      }
    },
    addFriend() {
      //if (!this.sourceHash) return
      var url =
        "classin://www.eeo.cn/enterclass?cardTelephone=" +
        this.userInfo.telephone;
      if (window.browserVersion.mobile) {
        this.browserMobile(url);
      } else {
        this.browserPc(url);
      }
    },
    browserMobile(url) {
      if (!window.eeoRunWithoutWx()) {
        return;
      }
      if (window.browserVersion.android) {
        window.location.href = url;
        this.$root.loading = true;
        setTimeout(() => {
          this.$root.loading = false;
          window.location.href = url;
          const tipClass = this.isMobile ? 'copy-success-tipM' : 'copy-success-tip'
          window.vant.Toast({
            message: this.$t('addfriend.noAppTip'),
            className: tipClass,
          });
        }, 3000);
      }
      if (window.browserVersion.ios) {
        var newUrl = window.location.href.replace('//share', '//static');
        setTimeout(() => {
          window.location.href = newUrl;
        }, 200);
      }
    },
    browserPc(url) {
      var callBack = () => {
        if (window.browserVersion.chrome) {
          window.location = url;
        } else {
          var iframe = document.createElement("iframe");
          iframe.src = url;
          iframe.style.display = "none";
          document.body.appendChild(iframe);
          this.$nextTick(() => {
            iframe.parentNode.removeChild(iframe);
          });
        }
      };
      window.eeoRunWithoutWx(callBack);
    },
    handler() {
      this.$refs.login &&
        this.$refs.login.showAreaList &&
        (this.$refs.login.showAreaList = false);
    },
    isSupportIosVersion() {
			if (!window.browserVersion.ios) {
				return false;
			}
			var ver = window.navigator.userAgent.toLowerCase().match(/os (.*?) like mac os/);
			if (!ver) {
				return true
			}
			var minVer = '9';
			var minVerArr = minVer.split('_');
			var currentVerArr = ver[1].split('_');
			var verLen = currentVerArr.length;
			while (minVerArr.length < verLen) {
				minVerArr.push('0')
			}
			var isSupport = false;
			var i = 0;
			var compare = function (minVer, currentVer) {
				if (minVer < currentVer) {
					isSupport = true;
				} else if (minVer > currentVer) {
					isSupport = false;
				}
			}
			for (let i = 0; i < verLen; i++) {
				if (minVerArr[i] * 1 == currentVerArr[i] * 1) {
					if (i == verLen - 1) {
						isSupport = true;
					} else {
						compare(minVerArr[i] * 1, currentVerArr[i] * 1);
					}
				} else {
					compare(minVerArr[i] * 1, currentVerArr[i] * 1)
					return isSupport
				}
			}
			return isSupport
		},
    showDownloadImg() {
      this.showMask = true
      document.body.style = `
        height: 100%;
        overflow: hidden;
      `
    },
    hideDownloadImg() {
      this.showMask = false
      document.body.style = `
        height: auto;
        overflow: auto;
      `
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 375px;
  height: auto;
  margin: 0 auto;
  // background-image: url("../../assets/images/b/bg.png");
  background-color: #f5f5f5;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #696464;
  padding: 12px 20px 0;
  font-size: 12px;
  position: relative;
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    z-index: 999;
    .van-loading__circular {
      color: #009265;
    }
  }
  .top {
    width: 100%;
    height: 150px;
    background-image: url("../../assets/images/b/top.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    .qr-img {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 36px;
      height: 36px;
      cursor: pointer;
    }
    .avatar {
      position: absolute;
      width: 54px;
      height: 54px;
      margin: 0 auto;
      border-radius: 50%;
      bottom: -27px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .middle {
    margin-bottom: 40px;
    padding-top: 34px;
    padding-bottom: 44px;
    width: 100%;
    height: auto;
    // background-image: url("../../assets/images/b/middle.png");
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: inline-block;
    .name {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      margin-top: 7px;
      height: 21px;
    }
    .content {
      display: block;
      width: 300px;
      margin: 0 auto;
      font-size: 16px;
      font-weight: 400;
      color: #000;
      line-height: 24px;
      text-align: center;
      margin-top: 57.5px;
    }
    .download {
      display: block;
      width: 270px;
      height: 44px;
      margin: 0 auto;
      background: #009265;
      border: none;
      border-radius: 5px;
      margin-top: 79.5px;
      color: #fff;
      font-size: 18px;
      line-height: 44px;
      text-align: center;
      cursor: pointer;
      position: relative;
      z-index: 2;
    }
    .clickOpen {
      text-align: center;
      color: #009265;
      font-size: 14px;
      margin-top: 24px;
      cursor: pointer;
    }
  }
  &.mb {
    width: 750px;
    min-height: 100vh;
    padding: 24px 40px 0;
    font-size: 24px;
    .top {
      height: 300px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      .qr-img {
        top: 20px;
        right: 20px;
        width: 72px;
        height: 72px;
      }
      .avatar {
        width: 108px;
        height: 108px;
        bottom: -54px;
      }
    }
    .middle {
      margin-bottom: 80px;
      padding-top: 68px;
      padding-bottom: 88px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
      .name {
        font-size: 32px;
        margin-top: 14px;
        height: 42px;
      }
      .content {
        width: 600px;
        font-size: 32px;
        line-height: 48px;
        margin-top: 115px;
      }
      .download {
        width: 540px;
        height: 88px;
        border-radius: 10px;
        margin-top: 159px;
        font-size: 36px;
        line-height: 88px;
      }
      .clickOpen {
        font-size: 28px;
        margin-top: 48px;
      }
    }
    .bottom {
      height: 170px;
    }
  }
}
</style>
